<template>
  <h1>reports</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>